/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};

/*
 * Product recommendations ("You may also like") for sections/product__recommendations.liquid.
 *
 * This file had been overwritten with the Recently viewed code, so the section never loaded
 * anything. Restored to the Flex pattern: fetch the section through Shopify's
 * Product Recommendations endpoint (which fills the `recommendations` Liquid object),
 * swap the rendered markup in, then re-run the theme's slider/currency hooks.
 */
window.PXUTheme.jsRecommendedProducts = {
  init: function ($section) {
    // Add settings from schema to current object
    window.PXUTheme.jsRecommendedProducts = $.extend(this, window.PXUTheme.getSectionData($section));

    const $wrapper = $section.find('.product-recommendations');
    if (!$wrapper.length) return;

    if (String($wrapper.data('enabled')) !== 'true') return;

    // Tag-based related collection is rendered server side already
    if (this.show_custom_collection === true) {
      $wrapper.removeAttr('hidden');
      this.initSliders();
      return;
    }

    if ($wrapper.data('loaded') === true) return;

    const baseUrl = ($wrapper.data('base-url') || '/recommendations/products').toString();
    const productId = $wrapper.data('product-id');
    const sectionId = $wrapper.data('section-id');
    const limit = parseInt($wrapper.data('limit'), 10) || 6;

    if (!productId || !sectionId) return;

    const url = `${baseUrl}?section_id=${encodeURIComponent(sectionId)}&product_id=${encodeURIComponent(productId)}&limit=${limit}`;

    $.ajax({ type: 'GET', url: url })
      .done((html) => {
        const $fetched = $('<div>').html(html).find('.product-recommendations').first();

        if (!$fetched.length || !$fetched.find('.product-wrap').length) {
          // No recommendations for this product: leave the section hidden
          $wrapper.attr('hidden', '');
          return;
        }

        $wrapper.html($fetched.html());
        $wrapper.data('loaded', true);
        $wrapper.removeAttr('hidden');

        this.initSliders();

        if (window.PXUTheme.currencyConverter && typeof window.PXUTheme.currencyConverter.convertCurrencies === 'function') {
          window.PXUTheme.currencyConverter.convertCurrencies();
        }

        $(document).trigger('oz:recommendations:loaded', [$wrapper]);
      })
      .fail(() => {
        $wrapper.attr('hidden', '');
      });
  },
  initSliders: function () {
    if (window.PXUTheme.jsProduct && typeof window.PXUTheme.jsProduct.relatedProducts === 'function') {
      window.PXUTheme.jsProduct.relatedProducts();
    }
  },
  unload: function ($section) {
    $section.find('.js-related-products-slider .products-slider').each((_, slider) => {
      const $slider = $(slider);
      if ($slider.data('flickity')) {
        $slider.flickity('destroy');
      }
    });
  }
};

/******/ })()
;
